import React from 'react';
import { ButtonContained, ButtonOutlined, ButtonLabel } from './styles';

type Props = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
    outlined?: boolean;
    label?: boolean;
    primaryColor?: boolean;
    children: React.ReactNode;
}

const Button: React.FC<Props> = ({ outlined = false, label = false, primaryColor = true, children, ...rest }) => {

    if (outlined)
        return (
            <ButtonOutlined $primaryColor={primaryColor} {...rest}>{children}</ButtonOutlined>
        );

    if (label)
        return (
            <ButtonLabel $primaryColor={primaryColor} {...rest}>{children}</ButtonLabel>
        );

    return (
        <ButtonContained $primaryColor={primaryColor} {...rest}>{children}</ButtonContained>
    );
};

export { Button };
